// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AlertController from "./alert_controller"
application.register("alert", AlertController)
import BloqueioModalController from "./bloqueio_modal_controller"
application.register("bloqueio-modal", BloqueioModalController)

import BoletoModalController from "./boleto_modal_controller"
application.register("boleto-modal", BoletoModalController)

import BonificacaoFilterController from "./bonificacao_filter_controller"
application.register("bonificacao-filter", BonificacaoFilterController)

import BulkAutoSelectController from "./bulk_auto_select_controller"
application.register("bulk-auto-select", BulkAutoSelectController)

import BulkSelectionController from "./bulk_selection_controller"
application.register("bulk-selection", BulkSelectionController)

import CartoesEmitirFilterController from "./cartoes_emitir_filter_controller"
application.register("cartoes-emitir-filter", CartoesEmitirFilterController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import CkeditorController from "./ckeditor_controller"
application.register("ckeditor", CkeditorController)

import ConditionalFieldsController from "./conditional_fields_controller"
application.register("conditional-fields", ConditionalFieldsController)

import ConfirmController from "./confirm_controller"
application.register("confirm", ConfirmController)

import ContratoFormController from "./contrato_form_controller"
application.register("contrato-form", ContratoFormController)

import ContratoPrazoController from "./contrato_prazo_controller"
application.register("contrato-prazo", ContratoPrazoController)

import DatepickerController from "./datepicker_controller"
application.register("datepicker", DatepickerController)

import DocumentMaskController from "./document_mask_controller"
application.register("document-mask", DocumentMaskController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import ExpandController from "./expand_controller"
application.register("expand", ExpandController)

import FormCalculatorController from "./form_calculator_controller"
application.register("form-calculator", FormCalculatorController)

import FormGuardController from "./form_guard_controller"
application.register("form-guard", FormGuardController)

import FuelCalculatorController from "./fuel_calculator_controller"
application.register("fuel-calculator", FuelCalculatorController)

import GraficosPainelController from "./graficos_painel_controller"
application.register("graficos-painel", GraficosPainelController)

import InputMaskController from "./input_mask_controller"
application.register("input-mask", InputMaskController)

import LancamentoEstabelecimentoController from "./lancamento_estabelecimento_controller"
application.register("lancamento-estabelecimento", LancamentoEstabelecimentoController)

import MegaMenuController from "./mega_menu_controller"
application.register("mega-menu", MegaMenuController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import ModalSelectionController from "./modal_selection_controller"
application.register("modal-selection", ModalSelectionController)

import MutuallyExclusiveCheckboxesController from "./mutually_exclusive_checkboxes_controller"
application.register("mutually-exclusive-checkboxes", MutuallyExclusiveCheckboxesController)

import NavigateOnChangeController from "./navigate_on_change_controller"
application.register("navigate-on-change", NavigateOnChangeController)

import NotificationController from "./notification_controller"
application.register("notification", NotificationController)

import PagamentoModalController from "./pagamento_modal_controller"
application.register("pagamento-modal", PagamentoModalController)

import PaymentTotalController from "./payment_total_controller"
application.register("payment-total", PaymentTotalController)

import QrScannerController from "./qr_scanner_controller"
application.register("qr-scanner", QrScannerController)

import RecaptchaRefreshController from "./recaptcha_refresh_controller"
application.register("recaptcha-refresh", RecaptchaRefreshController)

import RevealController from "./reveal_controller"
application.register("reveal", RevealController)

import SaleFormController from "./sale_form_controller"
application.register("sale-form", SaleFormController)

import ScrollShadowController from "./scroll_shadow_controller"
application.register("scroll-shadow", ScrollShadowController)

import SolicitacaoFormController from "./solicitacao_form_controller"
application.register("solicitacao-form", SolicitacaoFormController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import ToggleAllCheckboxesController from "./toggle_all_checkboxes_controller"
application.register("toggle-all-checkboxes", ToggleAllCheckboxesController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)
